import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../constant/queryKey';
import { goodsService } from 'shared/src/api/goodsService';
import { useGoodsSno } from '../hooks/useGoodsSno';
import { useFixedCouponSno } from '../hooks/useFixedCouponSno';

export const useGoodsBasic = () => {
  const goodsSno = useGoodsSno();
  const fixedCouponSno = useFixedCouponSno();
  return useQuery({
    queryKey: queryKey.goodsBasic(goodsSno, fixedCouponSno),
    queryFn: () => goodsService.getGoodsBasic(goodsSno, fixedCouponSno),
    throwOnError: true,
  });
};
